"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/fee-type.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Ffee-type.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.feeTypeToJSON = exports.feeTypeFromJSON = exports.FeeType = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.common.fee.proto';
var FeeType;
(function (FeeType) {
    FeeType["INVALID_FEE_TYPE"] = "INVALID_FEE_TYPE";
    FeeType["BNPL_REACTIVATION"] = "BNPL_REACTIVATION";
    FeeType["OVERDRAFT_PROTECTION_REACTIVATION"] = "OVERDRAFT_PROTECTION_REACTIVATION";
    FeeType["PHYSICAL_CARD_REPLACEMENT"] = "PHYSICAL_CARD_REPLACEMENT";
    FeeType["LENDING_REACTIVATION"] = "LENDING_REACTIVATION";
    FeeType["NEW_PHYSICAL_CARD"] = "NEW_PHYSICAL_CARD";
    /**
     * _TEST_MULTI_ACTIVE - TESTING ONLY - A fee that supports multiple unpaid instances per user.
     */
    FeeType["_TEST_MULTI_ACTIVE"] = "_TEST_MULTI_ACTIVE";
    FeeType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(FeeType || (exports.FeeType = FeeType = {}));
function feeTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_FEE_TYPE':
            return FeeType.INVALID_FEE_TYPE;
        case 1:
        case 'BNPL_REACTIVATION':
            return FeeType.BNPL_REACTIVATION;
        case 2:
        case 'OVERDRAFT_PROTECTION_REACTIVATION':
            return FeeType.OVERDRAFT_PROTECTION_REACTIVATION;
        case 3:
        case 'PHYSICAL_CARD_REPLACEMENT':
            return FeeType.PHYSICAL_CARD_REPLACEMENT;
        case 4:
        case 'LENDING_REACTIVATION':
            return FeeType.LENDING_REACTIVATION;
        case 5:
        case 'NEW_PHYSICAL_CARD':
            return FeeType.NEW_PHYSICAL_CARD;
        case 10000:
        case '_TEST_MULTI_ACTIVE':
            return FeeType._TEST_MULTI_ACTIVE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return FeeType.UNRECOGNIZED;
    }
}
exports.feeTypeFromJSON = feeTypeFromJSON;
function feeTypeToJSON(object) {
    switch (object) {
        case FeeType.INVALID_FEE_TYPE:
            return 'INVALID_FEE_TYPE';
        case FeeType.BNPL_REACTIVATION:
            return 'BNPL_REACTIVATION';
        case FeeType.OVERDRAFT_PROTECTION_REACTIVATION:
            return 'OVERDRAFT_PROTECTION_REACTIVATION';
        case FeeType.PHYSICAL_CARD_REPLACEMENT:
            return 'PHYSICAL_CARD_REPLACEMENT';
        case FeeType.LENDING_REACTIVATION:
            return 'LENDING_REACTIVATION';
        case FeeType.NEW_PHYSICAL_CARD:
            return 'NEW_PHYSICAL_CARD';
        case FeeType._TEST_MULTI_ACTIVE:
            return '_TEST_MULTI_ACTIVE';
        case FeeType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.feeTypeToJSON = feeTypeToJSON;
//# sourceMappingURL=fee-type.js.map